export default class OptAllInModalService {
  constructor(private $bsModal, private $q) {
    'ngInject';
  }

  openModal(included: boolean) {
    let modalPromise = this.$q.defer();

    this.$bsModal({
      template: require('./optAllSystemsInModal.html'),
      controller: 'OptAllSystemsInModal',
      controllerAs: '$ctrl',
      backdrop: 'static',
      placement: 'center',
      dismissable: true,
      locals: {
        included,
        modalPromise: modalPromise
      }
    });

    return modalPromise.promise;
  }
}
